export enum ReportGroup {
  SUBJECTS = "subjects",
  INSTANCES = "instances",
  JUDGMENTS = "judgments",
  DISTRICTS = "districts",
  AREAS = "areas"
}